var map = {
	"./1.jpeg": 2661,
	"./2.jpeg": 2388,
	"./3.jpg": 398,
	"./4.jpg": 6021,
	"./5.jpg": 5352,
	"./6.jpg": 1687,
	"./7.jpg": 3946,
	"./8.jpeg": 3030,
	"./9.jpg": 3252
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1082;